import { on } from 'delegated-events';
import Cookies from 'js-cookie';

const SELECTORS = Selectors({
  modalID: '[data-modalID]',
  modals: '.modal--page',
  closeButton: '.tingle-modal__close',
});

const props = {
  $modals: document.querySelectorAll(SELECTORS.modals),
  $closeButton: document.querySelector(SELECTORS.closeButton),
};

const fn = {
  init: () => {
    on('click', SELECTORS.closeButton, fn.handleClose);
    if (Cookies.get(document.querySelector(SELECTORS.modalID).getAttribute('data-modalID')) === 'close') {
      fn.handleClose;
    } else {
      props.$modals.forEach(modal => {
        modal.classList.add('tingle-modal--visible');
      });
    }
  },

  handleClose: () => {
    props.$modals.forEach(modal => {
      Cookies.set(document.querySelector(SELECTORS.modalID).getAttribute('data-modalID'), 'close', { expires: 1 });
      modal.classList.remove('tingle-modal--visible');
    });
  },
};

export default {
  can: () => props.$modals.length,
  run: fn.init,
};
